import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { FaCamera } from "react-icons/fa";
import basavannaImg from "./images/basavanna.jpeg";
import { baseUrl } from "../App";

function Login() {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({});
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navagate = useNavigate();

  const karnatakaDistricts = [
    "Bagalkot", "Ballari", "Belagavi", "Bengaluru Rural", "Bengaluru Urban", "Bidar", "Chamarajanagar", "Chikkaballapur", "Chikkamagaluru", "Chitradurga", "Dakshina Kannada", "Davanagere", "Dharwad", "Gadag", "Hassan", "Haveri", "Kalaburagi", "Kodagu", "Kolar", "Koppal", "Mandya", "Mysuru", "Raichur", "Ramanagara", "Shivamogga", "Tumakuru", "Udupi", "Uttara Kannada", "Vijayapura", "Yadgir"
  ];

  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "name") {
      newValue = value.replace(/[^a-zA-Z\s]/g, "");
    } else if (name === "mobile") {
      newValue = value.replace(/\D/g, "").slice(0, 10);
    } else if (name === "height") {
      newValue = value.replace(/[^0-9.]/g, "");
      if (newValue.split(".").length > 2) newValue = newValue.slice(0, -1);
    } else if (name === "weight") {
      newValue = value.replace(/[^0-9.]/g, "");
      if (newValue.split(".").length > 2) newValue = newValue.slice(0, -1);
    } else if (name === "annualIncome") {
      newValue = value;
    } else if (name === "birthTime") {
      newValue = value.replace(/[^0-9:APMapm\s]/g, "");
    } else if (name === "dateOfBirth") {
      const age = calculateAge(value);
      setFormData(prev => ({ ...prev, age, [name]: value }));
      return;
    }

    setFormData({ ...formData, [name]: newValue });
  };

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();

    try {
      if (isLogin) {
        data.append("email", formData.email);
        data.append("password", formData.password);

        if (formData.email === "admin@gmail.com") {
          const res = await axios.post(`${baseUrl}/login`, data);
          
          if (res.status === 200) {
            sessionStorage.setItem("userEmail", res.data.email);
            sessionStorage.setItem("userId", res.data.id);
            
            toast.success("Admin Login Successful");
            setTimeout(() => {
              navagate("/admindashboard");
            }, 2000);
          }
        } else {
          const res = await axios.post(`${baseUrl}/login`, data);
          
          sessionStorage.setItem("userEmail", res.data.email);
          sessionStorage.setItem("userId", res.data.id);
          
          toast.success("Login Successful");
          setTimeout(() => {
            navagate("/userdashboard");
          }, 2000);
        }
        
      } else {
        // REGISTER PART - Validations
        if (!formData.name || !/^[a-zA-Z\s]+$/.test(formData.name)) {
          toast.error("Name must contain only letters");
          return;
        }
        if (!formData.email || !formData.email.includes("@")) {
          toast.error("Email must contain @");
          return;
        }
        if (!formData.password) {
          toast.error("Password is required");
          return;
        }
        if (!formData.mobile || formData.mobile.length !== 10) {
          toast.error("Mobile must be 10 digits");
          return;
        }
        if (!formData.city) {
          toast.error("Please select a district");
          return;
        }
        if (!formData.address) {
          toast.error("Address is required");
          return;
        }
        if (!formData.gender) {
          toast.error("Please select gender");
          return;
        }
        if (!formData.dateOfBirth) {
          toast.error("Date of birth is required");
          return;
        }
        if ((formData.gender === "Male" && formData.age < 21) || (formData.gender === "Female" && formData.age < 18)) {
          toast.error(`Minimum age: ${formData.gender === "Male" ? "21" : "18"} years`);
          return;
        }
        if (!formData.aboutMe) {
          toast.error("About Me is required");
          return;
        }
        if (!formData.height) {
          toast.error("Height is required");
          return;
        }
        if (!formData.weight) {
          toast.error("Weight is required");
          return;
        }
        if (!formData.annualIncome) {
          toast.error("Annual income is required");
          return;
        }
        if (!formData.workLocation) {
          toast.error("Work location is required");
          return;
        }
        if (!formData.qualification) {
          toast.error("Qualification is required");
          return;
        }
        if (!formData.birthPlace) {
          toast.error("Birth place is required");
          return;
        }
        if (!formData.birthTime) {
          toast.error("Birth time is required");
          return;
        }
        if (!/^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i.test(formData.birthTime)) {
          toast.error("Birth time must be in format: 10:30 AM or 10:30AM");
          return;
        }
        if (!formData.raasi) {
          toast.error("Raasi is required");
          return;
        }
        if (!formData.star) {
          toast.error("Star is required");
          return;
        }
        if (!image) {
          toast.error("Profile photo is required");
          return;
        }

        Object.keys(formData).forEach((key) => {
          data.append(key, formData[key]);
        });

        data.append("profilePhoto", image);

        console.log("FormData contents:");
        for (let pair of data.entries()) {
          console.log(pair[0] + ": " + pair[1]);
        }
        console.log("Image file:", image);
        
        const res = await axios.post(`${baseUrl}/register`, data);
        console.log("Register Response Status:", res.status);
        console.log("Register Response Data:", res.data);
        console.log("Full Response Object:", res);

        if (res.data.ok === false) {
          toast.error(res.data.error);
          return;
        }

        toast.success("Registration Successful");

        // Auto-login after registration
        const loginData = new FormData();
        loginData.append("email", formData.email);
        loginData.append("password", formData.password);
        
        const loginRes = await axios.post(`${baseUrl}/login`, loginData);
        sessionStorage.setItem("userEmail", loginRes.data.email);
        sessionStorage.setItem("userId", loginRes.data.id);

        setTimeout(() => {
            navagate("/userdashboard");
          }, 500);
        setIsLogin(true);
      }
    } catch (error) {
      console.log("Server Error Status:", error.response?.status);
      console.log("Server Error Data:", error.response?.data);
      console.log("Full Error Object:", error);

      const errorMsg = error.response?.data?.error || error.response?.data?.message || error.message;
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };
    

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div 
        className="container-fluid d-flex justify-content-center align-items-center min-vh-100" 
        style={{ 
          backgroundImage: `url(${basavannaImg})`,
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '45%',
          backgroundColor: '#000'
        }}
      >
      <div className="card shadow p-4 w-100" style={{ maxWidth: "500px", backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
        
        <h3 className="text-center mb-4">
          {isLogin ? "Login" : "Register"}
        </h3>

        <form onSubmit={handleSubmit}>

          {isLogin ? (
            <>
              <div className="mb-3">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Email"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  placeholder="Password"
                  onChange={handleChange}
                  required
                />
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col-12 mb-2">
                  <input name="name" className="form-control" placeholder="Name" value={formData.name || ""} onChange={handleChange} />
                </div>

                <div className="col-12 mb-2">
                  <input type="text" name="email" className="form-control" placeholder="Email" onChange={handleChange} />
                </div>

                <div className="col-12 mb-2">
                  <input type="password" name="password" className="form-control" placeholder="Password" onChange={handleChange} />
                </div>

                <div className="col-6 mb-2">
                  <input name="mobile" className="form-control" placeholder="Mobile" value={formData.mobile || ""} maxLength="10" onChange={handleChange} />
                </div>

                <div className="col-6 mb-2">
                  <select name="city" className="form-control" onChange={handleChange}>
                    <option value="">Select District</option>
                    {karnatakaDistricts.map(district => <option key={district} value={district}>{district}</option>)}
                  </select>
                </div>

                <div className="col-12 mb-2">
                  <textarea name="address" className="form-control" placeholder="Address" onChange={handleChange} rows="2" />
                </div>

                <div className="col-6 mb-2">
                  <select name="gender" className="form-control" onChange={handleChange}>
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>

                <div className="col-6 mb-2">
                  <input type="date" name="dateOfBirth" className="form-control" max={formData.gender === "Male" ? new Date(new Date().setFullYear(new Date().getFullYear() - 21)).toISOString().split('T')[0] : new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0]} onChange={handleChange} />
                </div>

                <div className="col-12 mb-2">
                  <input type="number" name="age" className="form-control" placeholder="Age" value={formData.age || ""} readOnly />
                </div>

                <div className="col-12 mb-2">
                  <textarea name="aboutMe" className="form-control" placeholder="Please describe your job, yourself, and your hobbies." onChange={handleChange} rows="3" />
                </div>

                <div className="col-6 mb-2">
                  <input name="height" className="form-control" placeholder="Height (e.g., 5.11)" value={formData.height || ""} onChange={handleChange} />
                </div>

                <div className="col-6 mb-2">
                  <input name="weight" className="form-control" placeholder="Weight (e.g., 67.5)" value={formData.weight || ""} onChange={handleChange} />
                </div>

                <div className="col-6 mb-2">
                  <select name="annualIncome" className="form-control" onChange={handleChange}>
                    <option value="">Select Income</option>
                    <option value="1 to 4 LPA">1 to 4 LPA</option>
                    <option value="4 to 8 LPA">4 to 8 LPA</option>
                    <option value="8 to 12 LPA">8 to 12 LPA</option>
                    <option value="12 to 16 LPA">12 to 16 LPA</option>
                    <option value="16 to 20 LPA">16 to 20 LPA</option>
                    <option value="20 above LPA">20 above LPA</option>
                  </select>
                </div>

                <div className="col-6 mb-2">
                  <input name="workLocation" className="form-control" placeholder="Work Location" onChange={handleChange} />
                </div>

                <div className="col-12 mb-2">
                  <input name="qualification" className="form-control" placeholder="Qualification" onChange={handleChange} />
                </div>

                <div className="col-6 mb-2">
                  <input name="birthPlace" className="form-control" placeholder="Birth Place" onChange={handleChange} />
                </div>

                <div className="col-6 mb-2">
                  <input name="birthTime" className="form-control" placeholder="Birth Time (e.g., 10:30 AM)" value={formData.birthTime || ""} onChange={handleChange} />
                </div>

                <div className="col-6 mb-2">
                  <input name="raasi" className="form-control" placeholder="Raasi" onChange={handleChange} />
                </div>

                <div className="col-6 mb-3">
                  <input name="star" className="form-control" placeholder="Star" onChange={handleChange} />
                </div>

                <div className="col-12 mb-2">
                  <label className="form-label">Profile Pic</label>
                </div>

                <div className="col-12 mb-3 text-center">
                  <div className="position-relative d-inline-block">
                    <div
                      className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                      style={{
                        width: "120px",
                        height: "120px",
                        border: "3px solid #0d6efd",
                        overflow: "hidden"
                      }}
                    >
                      {image ? (
                        <img
                          src={URL.createObjectURL(image)}
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover"
                          }}
                        />
                      ) : (
                        <FaCamera size={40} color="#6c757d" />
                      )}
                    </div>
                    <label
                      htmlFor="profilePicUpload"
                      className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle p-2 shadow"
                      style={{ cursor: "pointer" }}
                    >
                      <FaCamera />
                    </label>
                    <input
                      type="file"
                      id="profilePicUpload"
                      hidden
                      onChange={handleImage}
                      accept="image/*"
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {isLogin ? "Logging in..." : "Registering..."}
              </>
            ) : (
              isLogin ? "Login" : "Register"
            )}
          </button>
        </form>

        <div className="text-center mt-3">
          {isLogin ? (
            <>
              Don't have an account?{" "}
              <span
                className="text-primary fw-bold"
                style={{ cursor: "pointer" }}
                onClick={() => setIsLogin(false)}
              >
                Register
              </span>
            </>
          ) : (
            <>
              Already have an account?{" "}
              <span
                className="text-primary fw-bold"
                style={{ cursor: "pointer" }}
                onClick={() => setIsLogin(true)}
              >
                Login
              </span>
            </>
          )}
        </div>

      </div>
      </div>
    </>
  );
}

export default Login;
